
export const staticRoutes = [
    { id: 'home', title: 'Home', icon: 'FaHome',  goTo: 'home' },
    // { id: 'history', title: 'History', icon: 'MdHistory', goTo: 'playlist/history' },
    { id: 'uploadNew', title: 'Upload video', icon: 'FaCloudUploadAlt', goTo: 'uploads/new' },
    { id: 'uploads', title: 'Your videos', icon: 'FaFileVideo', goTo: 'user/uploads' },
    { id: 'liked', title: 'Liked videos', icon: 'FaThumbsUp', goTo: 'user/liked' },
    { id: 'disliked', title: 'Disliked videos', icon: 'FaThumbsDown', goTo: 'user/disliked' }
]

export const watchLaterObj = { id: 'watch_later', title: 'Watch Later', items: [] };
        